import styles from './HeroSection.module.css';
import HeroTitle from './HeroTitle';
import HeroSubtitle from './HeroSubtitle';
import HeroCTAGroup from './HeroCTAGroup';

function HeroContent({ title, subtitle, cta, onCTAClick, onWordHover, hideCTA }) {
  return (
    <div className={styles.heroContent}>
      <HeroTitle onWordHover={onWordHover} />
      <HeroSubtitle>{subtitle}</HeroSubtitle>
      {!hideCTA && (
        <HeroCTAGroup
          primary={cta.primary}
          secondary={cta.secondary}
          onPrimaryClick={onCTAClick}
          onSecondaryClick={onCTAClick}
        />
      )}
    </div>
  );
}

export default HeroContent;
